import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const updateHistogramConfig = async ({ trialId, selections }) => {
  const token = localStorage.getItem("token");

  const res = await axios.put(
    `${__API_URL__}/api/ecrf/trial/${trialId}/histogram-config/`,
    { selections },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateHistogramConfigMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateHistogramConfig,
    onSuccess: (_, variables) => {
      toast.success("Histogram configuration saved");
      queryClient.invalidateQueries({
        queryKey: ["histogram_config", variables.trialId],
      });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to save histogram configuration");
    },
  });
};

export default useUpdateHistogramConfigMutation;
